<template>
    <div>
        <h2 class="text-md-center">Technical Skills</h2>
        <Skill :skills="Automation.skills" :skill-area="'Automation'"></Skill>
        <Skill :skills="cloudArch.skills" :skill-area="'Cloud Architecture'"></Skill>
        <Skill :skills="ai.skills" :skill-area="'AI'"></Skill>
        <Skill :skills="backEnd.skills" :skill-area="'Back End'"></Skill>
        <Skill :skills="frontEnd.skills" :skill-area="'Front End'"></Skill>
        <Skill :skills="QA.skills" :skill-area="'QA'"></Skill>
        <Skill :skills="Other.skills" :skill-area="'Other Skills'"></Skill>
    </div>
</template>

<script>
    import Skill from "@/components/Skill";

    export default {
        name: "SkillAreas",
        components: {
            Skill
        },
        data() {
            return {
                backEnd: {
                    skills: [
                        {
                            name: 'Spring',
                            expertise: 'Advanced'
                        },
                        {
                            name: 'Java',
                            expertise: 'Advanced'
                        },
                        {
                            name: 'Python',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Oracle',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Cassandra',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Databricks',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Ruby',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'C Plus Plus',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'C Sharp',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'GraphQL',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'Alexa Skill',
                            expertise: 'Apprentice'
                        }
                    ]
                },
                frontEnd: {
                    skills: [
                        {
                            name: 'HTML',
                            expertise: 'Advanced'
                        },
                        {
                            name: 'CSS',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Vue',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'JavaScript',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'React',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'React Native',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'JQuery',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'Angular',
                            expertise: 'Apprentice'
                        }
                    ]
                },
                Automation: {
                    skills: [
                        {
                            name: 'GitLab',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'CodeDeploy',
                            expertise: 'Intermediate'
                        },
                        {
                          name: 'Terraform',
                          expertise: 'Intermediate'
                        },
                        {
                            name: 'CloudFormation',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Docker',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Jenkins',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Heroku',
                            expertise: 'Apprentice'
                        }
                    ]
                },
                ai: {
                    skills: [
                        {
                            name: 'Model Context Protocol',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Prompt Engineering',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Bedrock',
                            expertise: 'Apprentice'
                        }
                    ]
                },
                cloudArch: {
                    skills: [
                        {
                            name: 'S3',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Lambda',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'DynamoDB',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'API Gateway',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Cognito',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'EC2',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Beanstalk',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'IAM',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'Aurora',
                            expertise: 'Apprentice'
                        },
                        {
                            name: 'AWS AppSync',
                            expertise: 'Apprentice'
                        },
                    ]
                },
                QA: {
                    skills: [
                        {
                            name: 'BrowserStack',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'PhantomJS',
                            expertise: 'Intermediate'
                        }
                    ]
                },
                Other: {
                    skills: [
                        {
                            name: 'Git',
                            expertise: 'Advanced'
                        },
                        {
                            name: 'Unix Systems',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Bash',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Networking',
                            expertise: 'Intermediate'
                        },
                        {
                            name: 'Windows Administration',
                            expertise: 'Intermediate'
                        },
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
